import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Box, Button, Paper, Stack, Typography, Chip,
  Table, TableBody, TableCell, TableHead, TableRow, IconButton, TablePagination,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import Swal from "sweetalert2";
import { listarEventos, excluirEvento } from "../../services/eventoService";
import { instituicaoDe } from "../../config/instituicoes";
import { fmtData as fmtDataSegura } from "../../utils/data";
import { usePaginacao } from "../../components/usePaginacao";

const fmt = (d) => fmtDataSegura(d, "—");

export default function EventoList() {
  const navigate = useNavigate();
  const [eventos, setEventos] = useState([]);

  const carregar = async () => {
    try { setEventos((await listarEventos()).data); }
    catch (e) { Swal.fire("Erro", e?.response?.data || e.message, "error"); }
  };
  useEffect(() => { carregar(); }, []);

  const excluir = async (id) => {
    const r = await Swal.fire({ title: "Inativar evento?", icon: "warning", showCancelButton: true, confirmButtonText: "Inativar", cancelButtonText: "Cancelar" });
    if (!r.isConfirmed) return;
    await excluirEvento(id); carregar();
  };

  // Paginação no navegador: a lista já vem filtrada do passo acima.
  const paginacao = usePaginacao(eventos);

  return (
    <Box>
      <Stack direction="row" justifyContent="space-between" alignItems="center" mb={2}>
        <Typography variant="h5">Eventos</Typography>
        <Button variant="contained" onClick={() => navigate("/eventos-admin/novo")}>Novo evento</Button>
      </Stack>

      <Paper>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>ID</TableCell>
              <TableCell>Nome</TableCell>
              <TableCell>Instituição</TableCell>
              <TableCell>Data</TableCell>
              <TableCell>Inscrições</TableCell>
              <TableCell>Taxa</TableCell>
              <TableCell align="center">Inscritos</TableCell>
              <TableCell align="center">Pagantes</TableCell>
              <TableCell align="center">Isentos</TableCell>
              <TableCell>Situação</TableCell>
              <TableCell align="center">Ações</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {paginacao.visiveis.map((e) => (
              <TableRow key={e.Id} hover sx={{ opacity: e.Ativo ? 1 : 0.5 }}>
                <TableCell>{e.Id}</TableCell>
                <TableCell>{e.Nome}</TableCell>
                <TableCell><Chip size="small" variant="outlined" label={instituicaoDe(e.Instituicao).nome} /></TableCell>
                <TableCell>{fmt(e.DataInicio)}</TableCell>
                <TableCell>{fmt(e.InicioInscricao)} a {fmt(e.FimInscricao)}</TableCell>
                <TableCell>{e.Pago ? <Chip size="small" label="Pago" color="primary" /> : <Chip size="small" label="Gratuito" variant="outlined" />}</TableCell>
                <TableCell align="center"><b>{e.QtdInscritos}</b></TableCell>
                <TableCell align="center">{e.QtdPagantes ?? 0}</TableCell>
                <TableCell align="center">{e.QtdIsentos ?? 0}</TableCell>
                <TableCell>
                  {!e.Ativo ? <Chip size="small" label="Inativo" />
                    : e.Visivel ? <Chip size="small" label="Publicado" color="success" />
                    : <Chip size="small" label="Oculto" color="warning" />}
                </TableCell>
                <TableCell align="center">
                  <IconButton size="small" title="Editar" onClick={() => navigate(`/eventos-admin/${e.Id}`)}><EditIcon fontSize="small" /></IconButton>
                  <IconButton size="small" color="error" onClick={() => excluir(e.Id)}><DeleteIcon fontSize="small" /></IconButton>
                </TableCell>
              </TableRow>
            ))}
            {eventos.length === 0 && (
              <TableRow><TableCell colSpan={11} align="center">Nenhum evento cadastrado.</TableCell></TableRow>
            )}
          </TableBody>
        </Table>
        <TablePagination {...paginacao.props} />
      </Paper>
    </Box>
  );
}
